import { SimpleField } from "./simpleField.jsx";
import { contactLabel } from "../../services/labels.jsx";
import React from "react";
import { useResource } from "../../hooks/useResource.js";

export function ContactField({ control, setValue, afterLabel, className }) {
  let contactsService = useResource("contacts");

  return (
    <SimpleField
      label="Contact"
      className={className}
      name={"contact"}
      control={control}
      afterLabel={afterLabel}
      type={"select"}
      select={{
        loadFunction: async (input) => {
          return contactsService.list({
            pageSize: 100,
            sort: "company",
            search: input,
          });
        },
        createFunction: async (input) => {
          setValue("contact", await contactsService.create({ company: input }));
        },
        labelFunction: (data, b, c, d) => {
          if (data.__isNew__) {
            return data.label;
          } else {
            return <div>{contactLabel(data)}</div>;
          }
        },
      }}
    />
  );
}
